module.exports = __webpack_public_path__ + "welcome-summary-v3.ef0be3085108f3058d79779c235354e4.svg";